import {
  TolErrorsActions,
  TolErrorsMutations,
  TolErrorsGetters
} from '@/app/features/tol-errors/tol-errors.keys';

export const getInitialState = () => {
  return {
    items: [],
    message: '',
    errorObject: {},
    keepOnce: false,
    isServiceUnavailable: false
  };
};

export const errorsStore = {
  state: getInitialState(),
  getters: {
    [TolErrorsGetters.HasErrors]: state => {
      return state.message || Object.keys(state.errorObject).length || state.items.length;
    },
    [TolErrorsGetters.ErrorObject]: state => state.errorObject,
    [TolErrorsGetters.Message]: state => state.message,
    [TolErrorsGetters.Items]: state => state.items,
    [TolErrorsGetters.Item]: state => idx => state.items[idx],
    [TolErrorsGetters.KeepOnce]: state => state.keepOnce,
    [TolErrorsGetters.ServiceUnavailable]: state => state.isServiceUnavailable
  },
  mutations: {
    [TolErrorsMutations.SetErrorObject]: function(state, errorObject) {
      state.errorObject = errorObject;
    },
    [TolErrorsMutations.SetMessage]: function(state, message) {
      state.message = message;
    },
    [TolErrorsMutations.SetItems]: function(state, items) {
      state.items = items;
    },
    [TolErrorsMutations.AddItem]: function(state, item) {
      state.items.push(item);
    },
    [TolErrorsMutations.RemoveItemByIndex]: function(state, index) {
      state.items.splice(index, 1);
    },
    [TolErrorsMutations.SetKeepOnce]: function(state, keepOnce = true) {
      state.keepOnce = keepOnce;
    },
    [TolErrorsMutations.ResetErrorsState]: state => {
      Object.assign(state, getInitialState());
    },
    [TolErrorsMutations.SetServiceUnavailable]: (state, payload = true) => {
      state.isServiceUnavailable = payload;
    }
  },
  actions: {
    [TolErrorsActions.ClearAll]: function({ commit }) {
      commit(TolErrorsMutations.ResetErrorsState);
    },
    [TolErrorsActions.SetError]: function(
      { commit },
      { error = null, message = null, items = null }
    ) {
      if (error && !message) message = error.data ? error.data.message : error.message;
      if (error) commit(TolErrorsMutations.SetErrorObject, error);
      if (message) commit(TolErrorsMutations.SetMessage, message);
      if (items) commit(TolErrorsMutations.SetItems, items);
    },
    [TolErrorsActions.AddItem]: function({ commit }, item) {
      commit(TolErrorsMutations.AddItem, item);
    },
    [TolErrorsActions.RemoveItemByIndex]: function({ commit }, index) {
      commit(TolErrorsMutations.RemoveItemByIndex, index);
    },
    [TolErrorsActions.SetKeepOnce]: function({ commit }, keepOnce = true) {
      commit(TolErrorsMutations.SetKeepOnce, keepOnce);
    },
    [TolErrorsActions.SetServiceUnavailable]: ({ commit }) => {
      commit(TolErrorsMutations.SetServiceUnavailable);
    }
  }
};
